import { Inject, Injectable } from '@angular/core';
import { AtsNotificationService } from '@ats/notifications';
import { Apollo } from 'apollo-angular';
import { from, Observable, Subscriber } from 'rxjs';
import { delay, delayWhen } from 'rxjs/operators';
import { UTILITY_CONFIG } from '../tokens';
import { AtsUtilityConfig } from '../models';

const LOADER = 'delay-observer';

@Injectable({
	providedIn: 'root',
})
export class AtsOperatorService {
	private defaultDelay: number = 7000;

	constructor(
		private notifications: AtsNotificationService,
		private apollo: Apollo,
		@Inject(UTILITY_CONFIG) private config: AtsUtilityConfig
	) {
		if (config.defaultDelayInMS) {
			this.defaultDelay = config.defaultDelayInMS;
		}
	}

	delay = (delayInMS?: number) => (source: Observable<any>) => {
		const delayTime = delayInMS ? delayInMS : this.defaultDelay;
		this.notifications.load(LOADER);

		return new Observable((observer: Subscriber<any>) => {
			return source.pipe(delay(delayTime)).subscribe(
				obs => {
					this.notifications.unload(LOADER);
					observer.next(obs);
				},
				err => {
					this.notifications.unload(LOADER);
					observer.error(err);
				},
				() => {
					this.notifications.unload(LOADER);
					observer.complete();
				}
			);
		});
	};

	clearApolloCache = () => (source: Observable<any>) => {
		return new Observable((observer: Subscriber<any>) => {
			return source.pipe(delayWhen(() => from(this.apollo.client.resetStore()))).subscribe({
				next(x) {
					observer.next(x);
				},
				error(err) {
					observer.error(err);
				},
				complete() {
					observer.complete();
				},
			});
		});
	};
}
